import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=20c86f8d&scoped=true"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=ts"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=ts"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=20c86f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c86f8d",
  null
  
)

export default component.exports